"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERIES = exports.DEVICES = void 0;
// needs to be from lowest to highest viewport, used for Hide component
var DEVICES = ["smallMobile", "mediumMobile", "largeMobile", "tablet", "desktop", "largeDesktop"];
exports.DEVICES = DEVICES;
var QUERIES = {
  LARGEDESKTOP: "largeDesktop",
  DESKTOP: "desktop",
  TABLET: "tablet",
  LARGEMOBILE: "largeMobile",
  MEDIUMMOBILE: "mediumMobile"
};
exports.QUERIES = QUERIES;